import { useEffect, useState } from 'react';

/**
 * True when the React app is running inside the Electron shell.
 * Uses the `window.electron` global exposed by the preload contextBridge.
 */
export function useIsDesktop(): boolean {
  const [isDesktop, setIsDesktop] = useState<boolean>(
    typeof window !== 'undefined' && Boolean(window.electron),
  );

  useEffect(() => {
    setIsDesktop(typeof window !== 'undefined' && Boolean(window.electron));
  }, []);

  return isDesktop;
}
